import { CREATE_USER_ERROR } from "./error-codes.constants";
import ApiError from "../../errors/ApiError";

export class CreateUserError extends ApiError {
  constructor() {
    super(CREATE_USER_ERROR);
  }
}
